import {Component, EventEmitter, Output} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {Category} from "projects/store/src/app/enums";

enum AccountType {
  'cuenta-corriente'= 'Cuenta Corriente',
  'cuenta-ahorro'= 'Cuenta Ahorro'
}

@Component({
  selector: 'app-sales-payment-information',
  templateUrl: './sales-payment-information.component.html'
})
export class SalesPaymentInformationComponent {
  categoryCode: string;
  requestId: string;
  @Output() nextStepEvent = new EventEmitter();
  @Output() gotoStepEvent = new EventEmitter();

  constructor(private route: ActivatedRoute) {
    this.requestId = this.route.snapshot.params['request_id'];
    this.categoryCode = this.route.snapshot.params['category_code'];
  }

  onNextStep() {
    this.nextStepEvent.emit();
  }

  onGotoStep(stepCode: string) {
    this.gotoStepEvent.emit(stepCode);
  }

  protected readonly Category = Category;


}
